function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
import { showGuidedTourPopup } from '../view/GuidedTourPopup';
var TourHandler = /*#__PURE__*/function (_StateHandler) {
  function TourHandler(instance) {
    var _this;
    _classCallCheck(this, TourHandler);
    _this = _callSuper(this, TourHandler);
    _this.instance = instance;
    _this.sandbox = Oskari.getSandbox();
    _this.setState({
      step: 0,
      steps: [],
      position: null,
      loading: false
    });
    _this.popupControls = null;
    _this.initSteps();
    return _this;
  }
  _inherits(TourHandler, _StateHandler);
  return _createClass(TourHandler, [{
    key: "getName",
    value: function getName() {
      return 'GuidedTourHandler';
    }
  }, {
    key: "initSteps",
    value: function initSteps() {
      var delegate = {
        bundleName: this.instance.getName(),
        priority: 0,
        getTitle: function getTitle() {
          return Oskari.getMsg('GuidedTour', 'page1.title');
        },
        getContent: function getContent() {
          return Oskari.getMsg('GuidedTour', 'page1.message');
        }
      };
      this.addStep(delegate);
    }
  }, {
    key: "addStep",
    value: function addStep(stepDelegate) {
      var delegate = stepDelegate;
      if (this.instance.conf && this.instance.conf.steps) {
        delegate = this.handleDelegateConf(delegate, this.instance.conf.steps);
      }
      if (typeof delegate.priority === 'number') {
        var priorities = this.state.steps.map(function (d) {
          return d.priority;
        });
        var insertLocation = this.getPriorityIndex(priorities, delegate.priority);
        this.state.steps.splice(insertLocation, 0, delegate);
        if (this.state.step >= insertLocation && this.state.steps.length !== 1) {
          // correct current location
          this.updateState({
            step: this.state.step++
          });
        }
      } else {
        delegate.priority = this.state.steps[this.state.steps.length - 1].priority + 1;
        this.updateState({
          steps: [].concat(_toConsumableArray(this.state.steps), [delegate])
        });
      }
      this._showGuideContentForStep(this.state.step);
    }
  }, {
    key: "getPriorityIndex",
    value: function getPriorityIndex(priorities, newPriority) {
      var index = 0;
      if (priorities.length === 0) return 0;
      var length = priorities.length === 1 ? 1 : priorities.length - 1;
      while (index <= length) {
        if (newPriority <= priorities[index]) {
          return index;
        }
        index++;
      }
      return index;
    }
  }, {
    key: "handleDelegateConf",
    value: function handleDelegateConf(delegate, steps) {
      var _this2 = this;
      // step ordering
      var index = steps.map(function (s) {
        return s.bundleName;
      }).indexOf(delegate.bundleName);
      if (delegate.bundleName !== this.instance.getName()) {
        if (index < 0) {
          return;
        }
        delegate.priority = index + 1;
      }

      // custom content
      if (index >= 0) {
        var content = steps[index].content;
        if (content) {
          delegate.getContent = function () {
            // empty placeholder while loading
            return '';
          };
          this.getGuideContent(content, function (success, response) {
            if (success) {
              delegate.getContent = function () {
                return response.body;
              };
              delegate.getTitle = function () {
                return response.title;
              };
            } else {
              Oskari.log(_this2.instance.getName()).error('Failed to load guided tour content for step "' + steps[index].bundleName + '" with tags: ' + content);
            }
          });
        }
      }
      return delegate;
    }
  }, {
    key: "_showGuideContentForStep",
    value: function _showGuideContentForStep(stepIndex) {
      if (stepIndex !== this.state.step) {
        this.updateState({
          step: stepIndex
        });
      }
      var step = this.state.steps[stepIndex];
      var content = step.getContent();
      var title = step.getTitle();
      var links = [];
      if (typeof step.getLinks === 'function' && step.getLinks() !== null) {
        links = step.getLinks();
      }
      if (typeof step.show === 'function') {
        step.show();
      }
      this.openPopup(title, content, links);
    }
  }, {
    key: "getGuideContent",
    value: function getGuideContent(tags, callback) {
      jQuery.ajax({
        url: Oskari.urls.getRoute('GetArticlesByTag'),
        data: {
          tags: tags
        },
        type: 'GET',
        dataType: 'json',
        beforeSend: function beforeSend(x) {
          if (x && x.overrideMimeType) {
            x.overrideMimeType('application/j-son;charset=UTF-8');
          }
        },
        success: function success(resp) {
          /* eslint-disable n/no-callback-literal */
          if (resp && resp.articles[0] && resp.articles[0].content) {
            callback(true, resp.articles[0].content);
          } else {
            callback(false);
          }
        },
        error: function error() {
          callback(false);
        }
      });
    }
  }, {
    key: "popupCleanup",
    value: function popupCleanup() {
      var dontShowAgain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.popupControls) {
        this.popupControls.close();
      }
      this.popupControls = null;
      if (dontShowAgain) {
        jQuery.cookie('pti_tour_seen', '1', {
          expires: 365
        });
      }
      this.hide();
    }
  }, {
    key: "hide",
    value: function hide() {
      var step = this.state.steps[this.state.step];
      if (typeof step.hide === 'function') {
        step.hide();
      }
    }
  }, {
    key: "next",
    value: function next() {
      this.hide();
      this._showGuideContentForStep(++this.state.step);
    }
  }, {
    key: "previous",
    value: function previous() {
      this.hide();
      this._showGuideContentForStep(--this.state.step);
    }
  }, {
    key: "openPopup",
    value: function openPopup(title, content, links) {
      var _this3 = this;
      if (this.popupControls) {
        this.popupControls.update(title, content, links, this.state, this.getController(), function (dontShowAgain) {
          return _this3.popupCleanup(dontShowAgain);
        });
      } else {
        this.popupControls = showGuidedTourPopup(title, content, links, this.state, this.getController(), function (dontShowAgain) {
          return _this3.popupCleanup(dontShowAgain);
        });
      }
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(TourHandler, ['next', 'previous']);
export { wrapped as GuidedTourHandler };